import React from 'react'

interface LeadTimeIconProps {
  color?: string
  size?: number | string
  className?: string
}

export const LeadTimeIcon: React.FC<LeadTimeIconProps> = ({
  color = 'currentColor',
  size = 20,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" fill="none" />
    <path
      d="M12 6V12L16 14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default LeadTimeIcon
